import React from "react";
import { ProductImages } from "../assets/ProductImages";

export default function NeedProductCard({ product, onView }) {
  const ImageComponent = product.imageType && ProductImages[product.imageType];

  return (
    <article
      className="need-product-card"
      onClick={() => onView?.(product)}
      style={{ "--accent": product.accent }}
    >
      <h3 className="need-product-name">{product.name}</h3>
      <div className="need-product-photo" style={{ background: product.color }}>
        {product.image ? (
          <img src={product.image} alt={product.name} className="need-product-img" />
        ) : (
          ImageComponent && <ImageComponent accent={product.accent} />
        )}
      </div>
      <p className="need-product-desc">{product.description}</p>
      <div className="need-product-footer">
        <span className="need-product-contact-hint">Contact us for details</span>
      </div>
    </article>
  );
}
